import { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { apiAuth } from '@/lib/api';
import { useAuth } from '@/contexts/AuthContext';
import { AUTH } from '@/constants/testIds';
import { Loader2 } from 'lucide-react';

export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash;
    const match = hash.match(/session_id=([^&]+)/);
    if (!match) {
      navigate('/login');
      return;
    }
    const session_id = decodeURIComponent(match[1]);
    (async () => {
      try {
        const { data } = await apiAuth.exchangeSession(session_id);
        setUser(data.user);
        // Clean hash and go to dashboard
        window.history.replaceState({}, '', '/dashboard');
        navigate('/dashboard', { state: { user: data.user }, replace: true });
      } catch (e) {
        console.error('Auth callback failed', e);
        navigate('/login');
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div data-testid={AUTH.callbackLoader} className="min-h-screen flex items-center justify-center bg-stone-50">
      <div className="text-center">
        <Loader2 className="w-8 h-8 animate-spin text-[#DA291C] mx-auto mb-4" />
        <div className="text-sm font-bold uppercase tracking-[0.2em] text-stone-600">
          Authentification en cours...
        </div>
      </div>
    </div>
  );
}
